import React from 'react'
const FB = require('!!url!../img/facebook.png')
const Twitter = require('!!url!../img/twitter.png')

export class SocialButtons extends React.Component {
  render(){
    const { twitterText="", hashtags="" } = this.props
    const url = window.location.href
    return (
      <div className="ac-social-buttons">
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} 
           className="ac-social-button" target="_blank">
          <img src={FB} />
        </a>
        <a href={`https://twitter.com/intent/tweet?hashtags=${hashtags}&text=${twitterText}&tw_p=tweetbutton&url=${url}`} 
           className="ac-social-button" target="_blank">
          <img src={Twitter} />
        </a>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/SocialButtons.jsx
 **/